import React, { FC } from 'react'
import styles from './TogglePreLoader.module.scss'
import classNames from 'classnames'

export const TogglePreLoader: FC = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.Wrapper}>
        <div className={classNames(styles.Loader, styles.InnerContainer)} />
      </div>
    </div>
  )
}
